import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import Config from '../../../../Config';
import {
  setTabIndex,
  setArrowIndex,
  setShowTabItems,
  setSelectedMobileItem,
  setIndex,
  setNavButtonsCurrent,
  setNavButtonsNew,
  setSelfCareData,
  setUserData,
  setNavItemIndex,
  toggleTabButton,
  toggleMouseInHeader,
} from '../HeaderBlockSlice';
import '../desktopHeader.scss';
import TabMenu from './TabMenu';
import NavBar from './NavBar';

const DesktopHeader = (props) => {
  const [tabsUrlList, setTabsUrlList] = useState({[Config.basePath]: -1});

  const {
    headerData,
    authentication,
    isBusinessNavigation,
    setTabIndex,
    setNavButtonsCurrent,
    setNavButtonsNew,
    setSelfCareData,
    setUserData,
  } = props;
  const {tabs, tabIndex, navItemIndex, hideNavigation} = headerData;
  const {loginData} = authentication;

  useEffect(() => {
    if (tabs !== [] && tabs != undefined) {
      //console.log('[DesktopHeader] dispatch setNavButtonsCurrent');
      if (tabs[tabIndex]?.navButtonsCurrent?.value != null) setNavButtonsCurrent(tabs[tabIndex]?.navButtonsCurrent?.expandedValue);
      else setNavButtonsCurrent(null);

      if (tabs[tabIndex]?.navButtonsNew?.value != null) setNavButtonsNew(tabs[tabIndex]?.navButtonsNew?.expandedValue);
      else setNavButtonsNew(null);

      if (tabs[tabIndex]?.selfCareData?.value != null) setSelfCareData(tabs[tabIndex]?.selfCareData?.expandedValue[0]);
      else setSelfCareData(null);

      let isFullAuthenticated = loginData?.isFullAuthenticated;
      let isOtpAuthenticated = loginData?.isOtpAuthenticated;
      let isOtpExtendedAuthenticated = loginData?.isOtpExtendedAuthenticated ?? false;
      let contactNumber = loginData?.userDetails?.contactNumber;
      let firstName = loginData?.userDetails?.firstName;
      let lastName = loginData?.userDetails?.lastName;
      //console.log(authentication?.loginData.userDetails.IsContactPerson)
      let obj = {
        isFullAuthenticated: isFullAuthenticated,
        isOtpAuthenticated: isOtpAuthenticated,
        isOtpExtendedAuthenticated: isOtpExtendedAuthenticated,
        contactNumber: contactNumber,
        firstName: firstName,
        lastName: lastName,
      };

      setUserData(obj);
    }
  }, [tabs, tabIndex, loginData, isBusinessNavigation, setTabIndex, setNavButtonsCurrent, setNavButtonsNew, setSelfCareData, setUserData]);

  return (
    <>
      <div className='desktop-header-container-main'>
        <div className='header-container'>
          {!hideNavigation && <TabMenu props={props} />}
          <NavBar props={props} tabsUrlList={tabsUrlList} setTabsUrlList={setTabsUrlList} />
        </div>
      </div>
      <div style={{marginBottom: hideNavigation ? '64px' : '88px'}}></div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    headerData: state.Header,
    authentication: state.authentication,
    selfcarePage: state.selfcarePage,
    transactionData: state.cellcomTransactionSummary.transactionData,
  };
};

const mapDispatchToProps = {
  setTabIndex,
  setArrowIndex,
  setShowTabItems,
  setSelectedMobileItem,
  setIndex,
  setNavButtonsCurrent,
  setNavButtonsNew,
  setSelfCareData,
  setUserData,
  setNavItemIndex,
  toggleTabButton,
  toggleMouseInHeader,
};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopHeader);
